<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Stared" pageTitle="Stared" />
            <StaredContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import StaredContent from '../Stared/StaredContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'StaredPage',
    components: {
        MainHeader,
        PageTitle,
        StaredContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>